"use strict";
exports.__esModule = true;
exports["default"] = (function (manifests) {
    return function (identifier, options, bootstrap) {
        var _a;
        manifests.push((_a = {},
            _a[identifier] = {
                options: options,
                bootstrap: bootstrap
            },
            _a));
    };
});
//# sourceMappingURL=manifest.js.map